import * as tslib_1 from "tslib";
import { AbstractPageComponent } from 'src/app/shared/components/abstract-page/abstract-page.component';
var NewsDetailsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NewsDetailsComponent, _super);
    function NewsDetailsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTitle = 'News details page';
        _this.url = window.location.href;
        return _this;
    }
    return NewsDetailsComponent;
}(AbstractPageComponent));
export { NewsDetailsComponent };
